import type { RadioProps } from '@mui/material';

import { StyledRadio } from './Radio.styled.js';

export const Radio = (props: RadioProps) => {
  return <StyledRadio disableRipple {...props} />;
};
